import {
  Box,
  Flex,
  Heading,
  HStack,
  Icon,
  Image,
  Link,
  useColorModeValue as mode,
  Skeleton,
  Stack,
  Text,
} from "@chakra-ui/react";

import { FaArrowRight } from "react-icons/fa";
import { IoGameController } from "react-icons/io5";
import { Link as ReactLink } from "react-router-dom";

const LandingScreen = () => (
  <Box maxW='8xl' mx='auto' p={{ base: "0", lg: "12" }} minH='6xl'>
    <Stack direction={{ base: "column-reverse", lg: "row" }} spacing={{ base: "0", lg: "20" }}>
      <Box
        width={{ lg: "sm" }}
        transform={{ base: "translateY(-50%)", lg: "none" }}
        bg={{ base: mode("cyan.50", "gray.700"), lg: "transparent" }}
        mx={{ base: "6", md: "8", lg: "0" }}
        px={{ base: "6", md: "8", lg: "0" }}
        py={{ base: "6", md: "8", lg: "12" }}
      >
        <Stack spacing={{ base: "8", lg: "10" }}>
          <Stack spacing={{ base: "2", lg: "4" }}>
            <Flex alignItems='center'>
              <Icon as={IoGameController} h={12} w={12} color={mode("cyan.500", "yellow.200")} mr='2' />
              <Text fontSize='4xl' fontWeight='bold'>
                Game Freaks
              </Text>
            </Flex>
            <Heading size='md' fontWeight='normal'>
              Job Management System
            </Heading>
          </Stack>
          <HStack spacing='3'>
            <Link as={ReactLink} to='/dashboard' color={mode("cyan.500", "yellow.200")}>
              Enter
            </Link>
            <Icon color={mode("cyan.500", "yellow.200")} as={FaArrowRight} />
          </HStack>
        </Stack>
      </Box>
      <Flex flex='1' overflow='hidden'>
        <Image
          src={mode("images/game-consoles-6.jpg", "images/game-consoles-6.jpg")}
          fallback={<Skeleton />}
          maxH='500px'
          minW='300px'
          objectFit='cover'
          flex='1'
        />
      </Flex>
    </Stack>
  </Box>
);

export default LandingScreen;
